export default __webpack_public_path__ + "static/2-d232fbc29338264b3bbfe5f266218c94.png";